
import { topicToHtmlConf } from './elem-to-html';
import { insertTopicMenuConf } from './menu/index';
import { parseHtmlConf } from './parse-elem-html';
import topicPlugin from './plugin';
import { renderTopicConf } from './render-elem';

const link = {
  renderElems: [renderTopicConf],
  elemsToHtml: [topicToHtmlConf],
  parseElemsHtml: [parseHtmlConf],
  menus: [insertTopicMenuConf],
  editorPlugin: topicPlugin,
};

export default link;
